import { render, staticRenderFns } from "./lookUp.vue?vue&type=template&id=1f16b46d&scoped=true&"
import script from "./lookUp.vue?vue&type=script&lang=js&"
export * from "./lookUp.vue?vue&type=script&lang=js&"
import style0 from "./lookUp.vue?vue&type=style&index=0&id=1f16b46d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f16b46d",
  null
  
)

export default component.exports